module.exports = __webpack_public_path__ + "static/img/coupon_bg3.62971e7c.png";